import cn from 'classnames';

import { Icon } from 'ui/atoms/Icon/Icon';

import styles from './BrandLogo.module.scss';

/**
 * Global Database wordmark (public/storage/svg/base/logo-1.svg), used in place of
 * the "Global Database" text in page headings. Height tracks the surrounding font
 * size (em-based); a visually-hidden label keeps the accessible name and SEO copy.
 */
export const BrandLogo = ({ className }: { className?: string }) => (
  <span className={cn(styles.root, className)}>
    <Icon type="logo-1" className={styles.logo} preserveAspectRatio="xMidYMid meet" />
    <span className={styles.srOnly}>Global Database</span>
  </span>
);
